import React, { useEffect, useState } from "react";
import {
  ApplyBtn,
  reset,
  dropdowns,
  emissionFilterTooltip,
  addGMPVariableTypes,
  SavedBtn,
  DataSelection,
  HIERARCHY_FILTER_KEYS
} from "../../../util/constants";
import { Select } from "../../CommonUIComponents/Select/Select";
import { Button } from "../.."; 
import { useSelector, useDispatch } from "react-redux";
import { setGMPHierarchy } from "../../../store/slices/gmpSlice";
import { LoadingIndicatorEmbed } from "../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { Tooltip } from "../../CommonUIComponents/Tooltip/Tooltip";
import { setselectedUIAllFilters } from "../../../store/slices/gmpSlice";
import { Modal } from "../../CommonUIComponents/Modal/Modal";
import { EmissionIcon } from "../../../icons";

function ModalBody({ onApply }) {
  const dispatch = useDispatch();
  const hierarchialData = useSelector((state) => state.project.hierarchialData);
  const selectedUIAllFilters = useSelector(
    (state) => state.gmp.selectedUIAllFilters
  );
  
  const convertEmptyToBlank = (filters) => {
    if (!filters || Array.isArray(filters) || typeof filters !== 'object') return filters;
    const converted = { ...filters };
    Object.keys(converted).forEach(key => {
      if (Array.isArray(converted[key])) {
        converted[key] = converted[key].map(value => value === "" ? "(blank)" : value);
      }
    });
    return converted;
  };
  
  const [selectedUIfilters, setSelectedUIAllFilters] =
    useState(() => convertEmptyToBlank(selectedUIAllFilters));
  let dropdownOptions = hierarchialData;
  const gmp = useSelector((state) => state.gmp.gmp);
  const [showLoader, setLoader] = useState(false);
  const [hierarchySelection, setHierarchySelection] = useState(false);
  const [scopeValue, setScopeValue] = useState([]);
  const [errorMsg, setErrorMsg] = useState([]);
  const [validScopes, setValidScopes] = useState([]);
  const keys = HIERARCHY_FILTER_KEYS;
  const [errorInSelection, setErrorInSelection] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [filtersReady, setFiltersReady] = useState(false);
  const [payload, setPayload] = useState(null);
  const [isDropdownChanging, setDropdownChanging] = useState(false);
  const hasValidEntries = selectedUIfilters && Object.entries(selectedUIfilters).some(([key, value]) => {
    return Array.isArray(value) && value.length > 0; // Check if the value is an array and has elements
  });

  useEffect(() => {
    if (gmp?.gmpVariableType === addGMPVariableTypes.independent) {
      setSelectedUIAllFilters({});
      setHierarchySelection(false);
      dispatch(setGMPHierarchy({ gmpHierarchyData: {} }));
    }
  }, [gmp?.gmpVariableType, dispatch]);

  
    useEffect(() => {
       const updatedFilters = { ...selectedUIfilters };
        if (filtersReady) {
            const filters = {
                scope: selectedUIfilters["scope"],
                category_level1: selectedUIfilters["category_level1"]?.length > 0
                    ? selectedUIfilters["category_level1"]
                    : ["All"],
                category_level2: selectedUIfilters["category_level2"]?.length > 0
                    ? selectedUIfilters["category_level2"]
                    : ["All"],
                category_level3: selectedUIfilters["category_level3"]?.length > 0
                    ? selectedUIfilters["category_level3"]
                    : ["All"],
                region_level1: selectedUIfilters["region_level1"]?.length > 0
                    ? selectedUIfilters["region_level1"]
                    : ["All"],
                region_level2: selectedUIfilters["region_level2"]?.length > 0
                    ? selectedUIfilters["region_level2"]
                    : ["All"],
                region_level3: selectedUIfilters["region_level3"]?.length > 0
                    ? selectedUIfilters["region_level3"]
                    : ["All"],
                entity_level1: selectedUIfilters["entity_level1"]?.length > 0
                    ? selectedUIfilters["entity_level1"]
                    : ["All"],
                entity_level2: selectedUIfilters["entity_level2"]?.length > 0
                    ? selectedUIfilters["entity_level2"]
                    : ["All"],
                entity_level3: selectedUIfilters["entity_level3"]?.length > 0
                    ? selectedUIfilters["entity_level3"]
                    : ["All"],
                entity_level4: selectedUIfilters["entity_level4"]?.length > 0
                    ? selectedUIfilters["entity_level4"]
                    : ["All"],
                custom_specification1: selectedUIfilters["custom_specification1"]?.length > 0
                ? selectedUIfilters["custom_specification1"].map(value => value === "(blank)" ? "" : value)
                : ["All"],
                custom_specification2: selectedUIfilters["custom_specification2"]?.length > 0
                ? selectedUIfilters["custom_specification2"].map(value => value === "(blank)" ? "" : value)
                : ["All"],
                custom_specification3: selectedUIfilters["custom_specification3"]?.length > 0
                ? selectedUIfilters["custom_specification3"].map(value => value === "(blank)" ? "" : value)
                : ["All"],
            };
            const scope = ["All"];
            if(!filters?.scope || filters?.scope == undefined || filters?.scope?.length == 0){
              filters.scope = scope;
            }

            const constructedPayload = constructPayload(filters);
            setPayload(constructedPayload);
            const allFields = keys
            ?.map(k => k);
        
        const cleanedPayload = Object.fromEntries(
            Object.entries(selectedUIfilters)?.filter(
                ([_, value]) => !(Array.isArray(value) && value?.length === 0)
            )
        );

        const presentFields = Object.keys(cleanedPayload);
        const missingFields = allFields?.filter(
            field => !presentFields?.includes(field)
        );
        // const finalPayload = { ...selectedUIfilters };
        missingFields?.forEach(fieldId => {
            const value = updatedFilters[fieldId];
            if (!Array.isArray(value) || value?.length === 0) {
                updatedFilters[fieldId] = getDropdownValues(fieldId) ?? [];
                 if (!updatedFilters[fieldId]) {
            updatedFilters[fieldId] = [];
        }

        // Assuming finalPayload[fieldId] is a single value or an array of values
        const valuesToAdd = Array.isArray(updatedFilters[fieldId]) ? updatedFilters[fieldId] : [updatedFilters[fieldId]];

        // Use a Set to avoid duplicates
        const uniqueValues = new Set(updatedFilters[fieldId]);

        valuesToAdd.forEach(value => {
            uniqueValues.add(value); // Add each value to the Set
        });

        // Convert the Set back to an array and assign it to selectedUIfilters[fieldId]
        updatedFilters[fieldId] = Array.from(uniqueValues);

        const customValues = ['custom_specification1', 'custom_specification2', 'custom_specification3'];
        customValues.forEach(fieldId => {
          if (updatedFilters[fieldId]) {
              updatedFilters[fieldId] = Array.from(updatedFilters[fieldId]).map(value => value === "(blank)" ? "" : value);
          }          
        });
         setSelectedUIAllFilters(updatedFilters);
            }            
        });        
        
            dispatch(setGMPHierarchy({ gmpHierarchyData: constructedPayload }));
            dispatch(setselectedUIAllFilters({ selectedUIAllFilters: updatedFilters }));
            setFiltersReady(false); // Reset the readiness state
            setLoader(false);
            onApply();
        }
    }, [selectedUIfilters, filtersReady]);


  //Disabling dropdowns based on header filters selection
  const disableDropdowns = (label) => {
    switch (label) {
      case "Scope":
        if (gmp?.gmpVariableType === addGMPVariableTypes.independent) {
          return true;
        } else if (gmp?.gmpVariableType === addGMPVariableTypes.dependent) {
          return false;
        }
        break;
      case "Category 1":
      case "category_level1":
        if (
          selectedUIfilters?.scope?.length === 0 ||
          !selectedUIfilters.scope ||
          selectedUIfilters?.category_level1?.length === 0 ||
          !selectedUIfilters?.category_level1 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Category 2":
      case "category_level2":
        if (
          selectedUIfilters?.category_level2?.length === 0 ||
          !selectedUIfilters?.category_level2 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Category 3":
      case "category_level3":
        if (
          selectedUIfilters?.category_level3?.length === 0 ||
          !selectedUIfilters?.category_level3 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Region level 1":
      case "region_level1":
        if (
          selectedUIfilters?.scope?.length === 0 ||
          !selectedUIfilters.scope ||
          selectedUIfilters.region_level1?.length === 0 ||
          !selectedUIfilters.region_level1 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Region level 2":
      case "region_level2":
        if (
          selectedUIfilters.region_level2?.length === 0 ||
          !selectedUIfilters.region_level2 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Region level 3":
      case "region_level3":
        if (
          selectedUIfilters.region_level3?.length === 0 ||
          !selectedUIfilters.region_level3 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Entity level 1":
      case "entity_level1":
        if (
          selectedUIfilters?.scope?.length === 0 ||
          !selectedUIfilters.scope ||
          selectedUIfilters.entity_level1?.length === 0 ||
          !selectedUIfilters.entity_level1 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Entity level 2":
      case "entity_level2":
        if (
          selectedUIfilters.entity_level2?.length === 0 ||
          !selectedUIfilters.entity_level2 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Entity level 3":
      case "entity_level3":
        if (
          selectedUIfilters.entity_level3?.length === 0 ||
          !selectedUIfilters.entity_level3 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Entity level 4":
      case "entity_level4":
        if (
          selectedUIfilters.entity_level4?.length === 0 ||
          !selectedUIfilters.entity_level4 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Custom level 1":
      case "custom_specification1":
        if (
          selectedUIfilters?.scope?.length === 0 ||
          !selectedUIfilters.scope ||
          selectedUIfilters.custom_specification1?.length === 0 ||
          !selectedUIfilters.custom_specification1 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Custom level 2":
      case "custom_specification2":
        if (
          selectedUIfilters.custom_specification2?.length === 0 ||
          !selectedUIfilters.custom_specification2 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      case "Custom level 3":
      case "custom_specification3":
        if (
          selectedUIfilters.custom_specification3?.length === 0 ||
          !selectedUIfilters.custom_specification3 ||
          gmp?.gmpVariableType === addGMPVariableTypes.independent
        ) {
          return true;
        }
        break;
      default:
        return false;
    }
  };

  // Handling dropdown change

  const handleDropdownChange = async (event, fieldId, id) => {
    setDropdownChanging(true);
    dispatch(setGMPHierarchy({ gmpHierarchyData: {} }));
    setHierarchySelection(false);
    setScopeValue(event);
    switch (fieldId) {
      case "scope":
        // setScopeValue(event);
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          scope: event,
          // category_level1: [],
          // category_level2: [],
          // category_level3: [],
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "category_level1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          category_level1: event,
          // category_level2: [],
          // category_level3: [],
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "category_level2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          category_level2: event,
          // category_level3: [],
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "category_level3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          category_level3: event,
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "region_level1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          region_level1: event,
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "region_level2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          region_level2: event,
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "region_level3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          region_level3: event,
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level1: event,
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level2: event,
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level3: event,
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level4":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level4: event,
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "custom_specification1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          custom_specification1: event,
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "custom_specification2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          custom_specification2: event,
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "custom_specification3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          custom_specification3: event,
          latest_filter: fieldId,
        });        
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    handleValidationForSelections();    
  }, [selectedUIfilters]);

  const handleValidationForSelections = () => {
    const possibleCombinations = hierarchialData; // API data
    const selectedCombinations = selectedUIfilters; // User's selected filters
    let errors = [];
    let err = [];

    // Check if the selected scope has valid combinations
    if (selectedCombinations && selectedCombinations?.scope?.length > 0) {
      // Filter valid entries based on selected scopes
      const initialValidScopes = possibleCombinations.filter(item =>
        selectedCombinations.scope.includes(item.scope)
      );
      const recentlySelectedFilter = selectedCombinations.latest_filter;
      let recentlySelectedFilterLabel;
      gmp?.gmpDataSet?.tableHeaderData?.map(data => {
        if (data?.field === recentlySelectedFilter) {
          recentlySelectedFilterLabel = data?.headerName;
        }
      })
      const allOptions = possibleCombinations.map(item => item[recentlySelectedFilter]); // Extract all options based on the filter
      const uniqueAllOptions = [...new Set(allOptions)];
      const selectedCategories = selectedCombinations[recentlySelectedFilter];

      // Validate
      if (recentlySelectedFilter !== 'scope') {
        const validScopesToUse = validScopes?.length > 0 ? validScopes : initialValidScopes;
        const allSelected = uniqueAllOptions?.length === selectedCategories?.length &&
          uniqueAllOptions?.every(option => selectedCategories?.includes(option));

        selectedCombinations[recentlySelectedFilter]?.forEach(category => {
          const validCategories = validScopesToUse?.filter(item => item[recentlySelectedFilter] === category);
          if (validCategories?.length !== 0 && !allSelected) {
            setValidScopes(validCategories);
          }
          validCategories?.map(item => {
            if (!item[recentlySelectedFilter]?.includes(selectedCombinations[recentlySelectedFilter])) {
              err.push(true);
            }
          })
          // if((err.length !== 0 || validCategories?.length === 0) && errors?.length === 0 && !allSelected){
          //   errors.push(`Invalid selection for ${recentlySelectedFilterLabel}. It is not available for the selections.`);
          //   keys?.forEach(key => {
          //     if(selectedCombinations[key]?.length === 0 || selectedCombinations[key] == undefined){
          //       disableDropdowns(key);
          //       setErrorInSelection(true);
          //     }
          //   })
          // }
        });
      }
    }
    // Set error messages if any
    if (errors.length > 0) {
      setErrorMsg(errors);
    } else {
      setErrorMsg([]); // Clear errors if valid
      setErrorInSelection(false);
    }
  };
  // Populating the dropdown values
  const getDropdownValues = (fieldId) => {
    let dataset = [...dropdownOptions];
    const allArraysHaveValues = keys.every(key => {
        const field = key;
        return selectedUIfilters && selectedUIfilters[field] ? Array.isArray(selectedUIfilters[field]) && selectedUIfilters[field].length > 0 : false;
    });

    // Iterate through all keys to filter the dataset based on selected values
    keys.forEach(key => {
      if (key !== fieldId) { // Skip the current fieldId
        const selectedValues = selectedUIfilters && selectedUIfilters[key] || [];
        const datasett = dataset?.filter(element => selectedValues?.length > 0 ? (selectedValues?.includes(element[key]) || selectedValues.includes('(blank)')) : []);
        if (datasett?.length !== 0) {
          dataset = datasett;
        }
      }
    });      

    if(allArraysHaveValues && !isDropdownChanging){
      keys?.forEach(key => {
        const data = dataset?.filter(elem => {
          const elemValue = elem[key];
          const selectedValues = selectedUIfilters[key] || [];
          return selectedValues?.includes(elemValue) || (elemValue === "" && selectedValues?.includes("(blank)"));
        }) || [];
          if(data?.length !== 0){
          dataset = data;
          }          
      })      
    }

    // Get unique values for the current dropdown and sort them
    let array = [...new Set(dataset.map(element => element[fieldId]))];
    array = array.map(value => value === "" ? "(blank)" : value);
    array = array.sort();
    return array;
  };

  //Resetting the dropdowns
  const resetDropdowns = async () => {
    setDropdownChanging(false);
    dispatch(setGMPHierarchy({ gmpHierarchyData: {} }));
    setHierarchySelection(false);
    setFiltersApplied(false);
    setScopeValue([]);
    setSelectedUIAllFilters({});
    dispatch(setselectedUIAllFilters({ selectedUIAllFilters: {} }));
    setErrorMsg([]); // Clear errors if valid
    setErrorInSelection(false);
    setValidScopes([]);
  };

  //Applying the filters

  const applyFilters = async () => {
        setDropdownChanging(false);
        setLoader(true);
        setHierarchySelection(true);
        setFiltersApplied(true);
        // Call updateFilters with the new filters
        await updateFilters(selectedUIfilters);        
    };

    const updateFilters = async (newFilters) => {
        // Logic to update selectedUIfilters
        setSelectedUIAllFilters(newFilters);
        setFiltersReady(true); // Indicate that filters are ready
    };

  const constructPayload = (filters) => {
    let dropDownMetaData = [];
    const selectedScope = (filters?.scope || [])?.map((x) => {
      return { columnType: "Scope", columnValue: x };
    });
    const selectedCatLevel1 = filters?.category_level1?.map((x) => {
      return { columnType: "Category_level1", columnValue: x };
    });
    const selectedCatLevel2 = filters?.category_level2?.map((x) => {
      return { columnType: "Category_level2", columnValue: x };
    });
    const selectedCatLevel3 = filters?.category_level3?.map((x) => {
      return { columnType: "Category_level3", columnValue: x };
    });
    //Geo Data
    const selectedRegionLevel1 = filters?.region_level1?.map((x) => {
      return { columnType: "Region_level1", columnValue: x };
    });
    const selectedRegionLevel2 = filters?.region_level2?.map((x) => {
      return { columnType: "Region_level2", columnValue: x };
    });
    const selectedRegionLevel3 = filters?.region_level3?.map((x) => {
      return { columnType: "Region_level3", columnValue: x };
    });

    //Org Data
    const selectedEntityLevel1 = filters?.entity_level1?.map((x) => {
      return { columnType: "Entity_level1", columnValue: x };
    });
    const selectedEntityLevel2 = filters?.entity_level2?.map((x) => {
      return { columnType: "Entity_level2", columnValue: x };
    });
    const selectedEntityLevel3 = filters?.entity_level3?.map((x) => {
      return { columnType: "Entity_level3", columnValue: x };
    });
    const selectedEntityLevel4 = filters?.entity_level4?.map((x) => {
      return { columnType: "Entity_level4", columnValue: x };
    });
    const selectedCustom1 = filters?.custom_specification1?.map((x) => {
      return { columnType: "Custom_specification1", columnValue: x };
    });
    const selectedCustom2 = filters?.custom_specification2?.map((x) => {
      return { columnType: "Custom_specification2", columnValue: x };
    });
    const selectedCustom3 = filters?.custom_specification3?.map((x) => {
      return { columnType: "Custom_specification3", columnValue: x };
    });

    dropDownMetaData = [
      ...selectedScope,
      ...selectedCatLevel1,
      ...selectedCatLevel2,
      ...selectedCatLevel3,
      ...selectedRegionLevel1,
      ...selectedRegionLevel2,
      ...selectedRegionLevel3,
      ...selectedEntityLevel1,
      ...selectedEntityLevel2,
      ...selectedEntityLevel3,
      ...selectedEntityLevel4,
      ...selectedCustom1,
      ...selectedCustom2,
      ...selectedCustom3,
    ];
    return dropDownMetaData;
  };


  return (
    <div className="add-gmp-hieraachry-container">
      <div className="emission-filter-modal-content">
        {dropdowns.map((element) => {
          return (
            <div className="emission-filter-modal-content-main">
              <span className="emission-filter-modal-label" key={element.Name}>
                {element.Name} &nbsp;
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={element.tooltip}
                ></Tooltip>
              </span>
              <div className="emission-filter-modal-content-dropdowns">
                {element.dropdownList.map((dropdown) => {
                  return (
                    <div>
                      <span className="emission-filter-modal-content-dropdowns-label">
                        {dropdown.label}
                        {/* {dropdown.label === "Scope" ? (
                          <span className="required-star">*</span>
                        ) : (
                          ""
                        )} */}
                      </span>
                      <Select
                        options={getDropdownValues(dropdown.fieldId)}
                        disabled={errorInSelection ? disableDropdowns(dropdown.label) : false}
                        value={
                          selectedUIfilters && 
                          selectedUIfilters[dropdown.fieldId]
                            ? selectedUIfilters[dropdown.fieldId]
                            : []
                        }
                        onChange={(event) => {
                          handleDropdownChange(
                            event,
                            dropdown.fieldId,
                            dropdown.id
                          );
                        }}
                        multiple={true}
                        showSelectAllButton={true}
                      ></Select>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="emission-filter-modal-footer">
        {errorMsg && (
          <div style={{ color: 'red', marginTop: '10px' }}>
            {errorMsg}
          </div>
        )}
        <Button
          variant="primary-alt"
          onClick={() => {
            resetDropdowns();
          }}
          disabled={!hasValidEntries}
        >
          {reset}
        </Button>
        <LoadingIndicatorEmbed show={showLoader}>
          <Button
            variant="primary"
            onClick={() => applyFilters(selectedUIfilters)}
            disabled={!hasValidEntries}
          >
            {hierarchySelection === true ? SavedBtn : ApplyBtn}
          </Button>
        </LoadingIndicatorEmbed>
      </div>
    </div>
  );
}

export function GMPHierarchy({ isFilterOpen, onClose }) {
  return (
    <Modal
      show={isFilterOpen}
      onClose={onClose}
      header={
        <div className="emission-filter-modal-header">
          <span>{DataSelection}<span className="required-star">*</span></span>
          <Tooltip
            trigger={<EmissionIcon />}
            variant="ghost"
            tooltipText={emissionFilterTooltip}
          ></Tooltip>
        </div>
      }
      body={<ModalBody onApply={onClose}></ModalBody>}
      className={"emission-gmp-modal"}
    ></Modal>
  );
}
